import React from "react";
import Hero from "./components/Hero";
import Features from "./components/Features";
import CTA from "./components/CTA";

function App() {
  return (
    <div className="font-sans text-gray-900">
      <Hero />
      <Features />
      <CTA />
    </div>
  );
}

export default App;
